export type QueryValue = string | number | boolean | undefined | null;

/**
 * Builds a `?a=1&b=2` string, skipping undefined and null. Insertion order is preserved,
 * matching the order the old app concatenated its parameters in — and the backend
 * re-serializes in that same order before calling upstream.
 *
 * Empty string is KEPT, unlike a naive "skip falsy": `gte-project-ids=` is a real request
 * the old app made for an employee with no allocated projects (mainMenu.jsx passes the
 * joined project-id array, which is "" when the list is empty).
 *
 * Commas are left literal rather than percent-encoded, because the old app built these
 * by raw concatenation and upstream has only ever seen `gte-project-ids=1,2,3`. Comma is
 * a legal query sub-delim under RFC 3986.
 */
export function buildQueryString(params: Record<string, QueryValue>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      search.set(key, String(value));
    }
  }
  const serialized = search.toString().replace(/%2C/g, ',');
  return serialized ? `?${serialized}` : '';
}
